import React, { useEffect, useState } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Image from "next/image";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";
import { useBrochureUpdate } from "@/next-src/context/Brochure";
import { useNotifyUpdate } from "@/next-src/context/Notify";
import onClickCTAScrollTo from "@/next-src/utils/onClickCTAScrollTo";

import comCSS from "./ButtonLink.module.scss";

export const ACTIONS = {
  SHOW_BROCHURE: "show_brochure",
  SHOW_NOTIFY: "show_notify",
  SCROLL_TO_NEWSLETTER_SECTION: "scroll_to_newsletterSubscriptionSection",
};

const ButtonLink = ({
  data = {},
  className = "",
  onClick: onClickFn = () => {},
  isPulsingIcon = false,
  isPhoneIcon = false,
  target = "",
  isArrowRight = false,
  isDownloadIcon = false,
}) => {
  const { setIsShown: showBrochure } = useBrochureUpdate();
  const { setIsShown: showNotify } = useNotifyUpdate();
  const [cssHover, setCssHover] = useState("");
  const {
    id,
    text,
    btnTextBlack,
    url,
    bgColor,
    borderColor,
    hide,
    bgColorHover,
    borderColorHover,
    action,
  } = data || {};

  useEffect(() => {
    if (bgColorHover || borderColorHover) {
      setCssHover(`.button.btn-${id}-hover:hover {
            border-color: ${borderColorHover || ""} !important;
            background-color: ${bgColorHover || ""} !important;
          }
      `);
    }
  }, [bgColorHover, borderColorHover, setCssHover, id]);

  const attributes = {};
  if (target) attributes.target = target;

  if (hide || !text) return null;

  const onClick = (e) => {
    if (action === ACTIONS.SHOW_BROCHURE || url === "#brochure") {
      showBrochure(true);
      e.preventDefault();
      return;
    }

    if (action === ACTIONS.SHOW_NOTIFY) {
      e.preventDefault();
      showNotify(true);
      return;
    }
    if (action.startsWith("scroll_to_")) {
      const id = action.replace("scroll_to_", "");
      onClickCTAScrollTo(id)(e);
      e.preventDefault();
      return;
    }

    onClickFn(e);
  };

  return (
    <a
      id={id}
      href={url || "/"}
      className={cn(className, "button w-inline-block", {
        [comCSS.blackText]: btnTextBlack,
        [`btn-${id}-hover`]: bgColorHover || borderColorHover,
      })}
      style={{
        backgroundColor: bgColor || "",
        borderColor: borderColor || "",
      }}
      onClick={onClick}
      {...attributes}
    >
      <style>{cssHover}</style>
      {isPhoneIcon ? (
        <Image
          width={16}
          height={16}
          src="/images/home/64b7b352b7162cc04b74c422_phone.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xxsmall"
        />
      ) : null}
      {isDownloadIcon ? (
        <Image
          width={24}
          height={24}
          src="/images/home/63db8e89e8a2c669e01bef4b_download-icon.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xsmall"
        />
      ) : null}
      {isPulsingIcon ? (
        <div className={cn(comCSS.btnMark, "pulsing-btn-dot-div")} />
      ) : null}
      <div>{convertHTMLtoJSX(text)}</div>
      {isArrowRight ? (
        <Image
          width={24}
          height={24}
          src="/images/home/63dbb4719a269f7433156259_arrow_forward_btn-black.svg"
          loading="lazy"
          alt=""
          className="icon-1x1-xsmall"
        />
      ) : null}
    </a>
  );
};

ButtonLink.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    btnTextBlack: PropTypes.bool,
    url: PropTypes.string,
    bgColor: PropTypes.string,
    borderColor: PropTypes.string,
    hide: PropTypes.bool,
    enableShowMsgUs: PropTypes.bool,
    bgColorHover: PropTypes.string,
    borderColorHover: PropTypes.string,
    action: PropTypes.string,
  }),
  className: PropTypes.string,
  onClick: PropTypes.func,
  isPulsingIcon: PropTypes.bool,
  isPhoneIcon: PropTypes.bool,
};

export default ButtonLink;
